<div class="menu" [ngClass.gt-xs]="{ desktop: true }">
  <div>

    <mat-toolbar role="header" class="mat-elevation-z0">
      <mat-toolbar-row>
        <span>{{ 'MENU.TITLE_WELCOME' | translate }}</span>
        <ng-container *ngIf="userApiService.user$ | async as user">
          <span>{{user.name}}!</span>
        </ng-container>
        <span class="fill-remaining-space"></span>
        <i class="material-icons" (click)="onToggleMenu()" style="color: #ffffff; cursor: pointer;">close</i>
      </mat-toolbar-row>
    </mat-toolbar>

    <h3 class="no-padding">{{ 'MENU.SECTION_SETTINGS_LANGUAGE' | translate }}</h3>

    <ul>
      <li>
        <a (click)="setUserLanguage('en-GB');" [class.active]="selectedLanguage == 'en-GB'">{{ 'MENU.SECTION_SETTINGS_LANGUAGE_ENGLISH' | translate }}</a>
      </li>
      <li>
        <a (click)="setUserLanguage('fi');" [class.active]="selectedLanguage == 'fi'">{{ 'MENU.SECTION_SETTINGS_LANGUAGE_FINNISH' | translate }}</a>
      </li>
      <li>
        <a (click)="setUserLanguage('fr');" [class.active]="selectedLanguage == 'fr'">{{ 'MENU.SECTION_SETTINGS_LANGUAGE_FRENCH' | translate }}</a>
      </li>
    </ul>

    <h3>{{ 'MENU.TITLE_OTHER' | translate }}</h3>

    <ul>
      <li>
        <a class="links" (click)="onHelp()">{{ 'MENU.ACTION_CONTACT' | translate }}</a>
      </li>
      <li>
        <a class="links" (click)="onPrivacy()">{{ 'MENU.ACTION_PRIVACY' | translate }}</a>
      </li>
      <li>
        <a class="links" (click)="onLegal()">{{ 'MENU.ACTION_LEGAL' | translate }}</a>
      </li>
    </ul>
  </div>

  <div class="signout-button" (click)="logout()">
    <a mat-line class="link">{{ 'MENU.ACTION_LOGOUT' | translate }}</a>
  </div>

</div>
